import React from 'react'

import { IconSystemEye, IconSystemEyeClosed } from '@moonpig/launchpad-assets'
import { Box } from '@moonpig/launchpad-components'

export const PasswordVisibilityEyecon: React.FC<{
  isVisible: boolean
  setVisibility: (value: boolean) => void
}> = ({ isVisible, setVisibility }) => {
  const props = {
    width: '28px',
    height: '28px',
    cursor: 'pointer',

    onClick: /* istanbul ignore next */ () => setVisibility(!isVisible),
  }

  const icon = isVisible ? (
    /* istanbul ignore next */ <IconSystemEye {...props} />
  ) : (
    <IconSystemEyeClosed {...props} />
  )

  return (
    <Box
      height="48px"
      alignItems="center"
      display="flex"
      data-testid={`password-eyecon-${isVisible ? 'open' : 'closed'}`}
    >
      {icon}
    </Box>
  )
}
